import React, { useState } from "react";
import { hireAsteriskFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const AsteriskDeveloper = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };
  return (<>
    <Helmet>
      <meta name="description" content="Hire expert Asterisk developers in India for custom VoIP, PBX, and call center solutions. Boost your business efficiency with our skilled development team."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Dedicated Asterisk Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-asterisk-developers"/>
<meta property="og:description" content="Hire expert Asterisk developers in India for custom VoIP, PBX, and call center solutions. Boost your business efficiency with our skilled development team."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Dedicated Asterisk Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire expert Asterisk developers in India for custom VoIP, PBX, and call center solutions. Boost your business efficiency with our skilled development team."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-asterisk-developers"/>
<title>Hire Dedicated Asterisk Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16  ">
          <div className="lg:w-3/4 lg:text-left ">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 mt-10">
              Hire Dedicated Asterisk Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              Asterisk is an open-source framework designed for building
              communication applications. It serves as the backbone for IP PBX
              systems, VoIP gateways, conferencing servers, and other advanced
              communication solutions. Trusted by businesses of all sizes, call
              centers, telecom carriers, and government organizations globally,
              Asterisk is a cost-effective and robust telephone platform.
              <br /> Our skilled Asterisk developers can help you implement
              Asterisk as the foundation for a full-fledged business phone
              system, expand your existing setup, or seamlessly integrate
              multiple systems to fill operational gaps.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $18/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a Asterisk Developer
            </button>
          </div>

          <div className="flex justify-center  mb-6 ">
            <img
              src="\assets\images\headerSection\hireAsteriskDev\img1.png"
              alt="VoIP Business Solutions"
              className=" h-auto sm:w-3/4 md:w-2/3  object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Skills of Our Asterisk Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl  text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Partner with Ayanshtech Solutions to leverage the expertise of our
          Asterisk specialists, skilled in creating communication solutions such
          as IP PBX systems, VoIP gateways, call routing systems, and
          conferencing tools.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Proficient in SIP/SDP/RTP protocol handling
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Experienced in configuring Asterisk SIP Profiles and Dialplans
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Development of Asterisk AGI and FastAGI scripting solutions
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Advanced knowledge of Asterisk AMI and ARI interfaces
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Expertise in chan_sip and chan_pjsip module configurations
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Ability to set up Asterisk in High Availability (HA) mode
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Employ Expert Asterisk Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Leverage the expertise of our Asterisk developers to craft tailored
          solutions that align with your business objectives.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 p-4">
            <img
              src="\assets\images\headerSection\hireAsteriskDev\img2.webp"
              alt="Graph displayed on a laptop"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our developers assist businesses in maximizing the potential.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  We excel in Asterisk customization and empowered businesses
                  solutions.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our team comprises skilled and seasoned Asterisk developers.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  We specialize in developing both single-tenant and
                  multi-tenant Asterisk solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4 mt-6 w-full">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {hireAsteriskFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

       <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {hireAsteriskFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>


      <GetInTouch />
    </div>
  </>);
};

export default AsteriskDeveloper;
